import { paths } from "helpers/paths";
import React from "react";
import { Link } from "react-router-dom";

const CompoundBids = ({ compoundBidIds, id }) => {
    if (compoundBidIds.length === 0) {
        return null;
    }
    return (
        <>
            <div className="show-bid__main-info--title">Тип заявки</div>
            <div className="show-bid__main-info--value" data-test-id="compound">
                <div className="show-bid__main-info--badge">
                    <i className="show-bid__main-info--icon pr-1 icon-uEA76-animation-outline" />
                    Сборная
                </div>
            </div>
            <div className="show-bid__main-info--title">Список сборных заявок</div>
            <div className="show-bid__main-info--value">
                {compoundBidIds
                    .map((compoundId) => (
                        <Link
                            key={compoundId}
                            to={`${paths.bidShow("bid", compoundId)}?from=bid&bidId=${id}`}
                            data-test-id="compound-bid-id"
                        >
                            {compoundId}
                        </Link>
                    ))
                    .reduce((prev, curr) => [prev, ", ", curr])}
            </div>
        </>
    );
};

export default CompoundBids;
